"use strict";

var _httpCore = _interopRequireDefault(require("../httpCore"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
/**
 * 上传文件的 api
 */


_httpCore.default.createApi('uploadFile', {
  method: 'post',
  headers: {
    'Content-Type': 'multipart/form-data'
  }
});